const COLORS = {
    white: "#f9f9f9",
    black: "#212121",
    black_transparent: "rgba(33,33,33,0.5)",
    gold: "#d2a817ff",
}

export default COLORS